import { render, staticRenderFns } from "./CardAward.vue?vue&type=template&id=1524cf63"
import script from "./CardAward.vue?vue&type=script&lang=js"
export * from "./CardAward.vue?vue&type=script&lang=js"
import style0 from "./CardAward.vue?vue&type=style&index=0&id=1524cf63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports